import React, { useEffect } from "react";
import {
  Redirect,
  RouteComponentProps,
  useLocation,
  useNavigate,
} from "@reach/router";
import { useDispatch, useSelector } from "react-redux";
import { Spinner } from "components/Spinner/Spinner";
import { autologin, selectAuthMessage, selectAuthStatus } from "reducers/auth";

type Props = {};

export const AutoLogin = (props: Props & RouteComponentProps) => {
  const dispatch = useDispatch();

  const location = useLocation();
  const navigate = useNavigate();

  const authStatus = useSelector(selectAuthStatus);
  const authMessage = useSelector(selectAuthMessage);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get("token");
    if (token) {
      dispatch(autologin(token));
    } else {
      navigate("/sign-in");
    }
  }, [dispatch, location, navigate]);

  useEffect(() => {
    if (authStatus === "signed_out" && authMessage) {
      navigate("/sign-in");
    }
  }, [authMessage, authStatus, navigate]);

  if (authStatus === "signed_in") return <Redirect noThrow to="/" />;
  return (
    <div className="AutologinPage">
      <Spinner />
      <p>Logging you in...</p>
    </div>
  );
};
